import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Parallax } from 'react-scroll-parallax';

import LazyBg from '../../../UI/LazyImage/LazyBg';
import { createMarkup } from '../../../../utils/helpers';

import './ImageTreatmentLink.css';
import 'animate.css/animate.min.css';

class ImageTreatmentLink extends PureComponent {
    render() {
        const {
            orientation,
            linearOverlay,
            backgroundImage,
            title,
            subTitle,
            overlayOpacity,
            isLocalUrl,
            buttonLink,
            buttonTitle,
            backgroundPosition = 'bg-center'
        } = this.props;

        let color1 = '#26588D';
        let color2 = '#38C2D8';
        let topPolygonPoints = '0,0 65,0 35,100 0,100';

        if (orientation === 'right') {
            color1 = '#38C2D8';
            color2 = '#26588D';
            topPolygonPoints = '100,0 35,0 65,100 100,100';
        }

        if (!linearOverlay) {
            topPolygonPoints = '0,0 50,0 50,100 0,100';
            color1 = '#26588D';
            color2 = 'transparent';

            if (orientation === 'right') {
                color1 = 'transparent';
                color2 = '#26588D';
            }
        }

        return (
            <section className={`image-treatment-link-container ${orientation}`}>
                <div className="parallax-wrapper">
                    <Parallax className="parallax-image" y={[ 0, 0 ]}>
                        <LazyBg src={backgroundImage} className={`image-link ${backgroundPosition}`} />
                    </Parallax>
                </div>
                <div className="triangle-layer-container">
                    <Parallax className="parallax-image" x={[ 0, -35 ]}>
                        <div className="svg-triangle">
                            <svg preserveAspectRatio="xMidYMid slice" viewBox="0 0 80 100">
                                <polygon points={topPolygonPoints} opacity={overlayOpacity}></polygon>
                                <defs>
                                    <linearGradient id="light-to-dark-blue">
                                        <stop offset="0" stopColor={color1} />
                                        <stop offset="1" stopColor={color2} />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    </Parallax>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-offset-1-desktop is-4-tablet">
                                {subTitle && <div className="pre-title">{subTitle}</div>}
                                {title && <div className="big-title" dangerouslySetInnerHTML={createMarkup(title)} />}
                                
                                {isLocalUrl && buttonTitle &&  <Link className="btn-link button local" to={buttonLink}>
                                    <span>{buttonTitle}</span>
                                </Link>}
                             
                                {!isLocalUrl && buttonTitle && <a
                                    className="btn-link button outer"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={buttonLink}
                                >
                                    <span>{buttonTitle}</span>
                                </a>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

ImageTreatmentLink.propTypes = {
    stopColor1: PropTypes.string,
    stopColor2: PropTypes.string,
    buttonTitle: PropTypes.string,
    buttonLink: PropTypes.string,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    orientation: PropTypes.oneOf([ 'left', 'right' ]),
    backgroundImage: PropTypes.string,
    backgroundPosition: PropTypes.string,
    linearOverlay: PropTypes.bool,
    overlayOpacity: PropTypes.string,
    isLocalUrl: PropTypes.bool,
};

export default ImageTreatmentLink;
